<ppl-app-container>
  <div class="align-in-center">
    <ppl-box-container-with-title
      title="Forgot password?"
      i18n-title="@@Forgot_password?"
      [description]="description$ | async"
      [small]="true">
      @if (error$ | async; as error) {
        <ppl-error-box>
          @switch (error) {
            @case (ForgotPasswordError.ERROR_TOO_MANY_REQUESTS) {
              <span i18n="@@Too_many_requests._Please_try_again_later.">Too many requests. Please try again later.</span>
            }
            @default {
              <span i18n="@@Unknown_error.">Unknown error.</span>
            }
          }
        </ppl-error-box>
      }
      @if (!resetPasswordLinkSent) {
        <ppl-form-container [formGroup]="emailForm">
          <ppl-form-row>
            <ppl-input-container
              label="Email"
              i18n-label="@@Email"
              [pplFormControl]="emailForm.get('email')">
              <input
                pplInput
                formControlName="email"
                placeholder="Enter your email"
                i18n-placeholder="@@Enter_your_email"
                (keyup)="onKeyUp($event)" />
            </ppl-input-container>
          </ppl-form-row>
        </ppl-form-container>
        <div class="buttons">
          <button
            pplButton
            i18n="@@Send_link"
            class="submit-button"
            (click)="onSubmit()">
            Send link
          </button>
          <a
            role="button"
            tabindex="0"
            i18n="@@Back_to_Login"
            class="link"
            (click)="onGoBack()"
            >Back to Login</a
          >
        </div>
        @if (sending$ | async) {
          <ppl-loading-overlay
            [large]="true"
            [visible]="true"
            [inverse]="true"></ppl-loading-overlay>
        }
      }
    </ppl-box-container-with-title>
  </div>
</ppl-app-container>
